import { set } from '../partials/locker';
import { getUser } from '@/store/partials/user'
import Vue from 'vue';

let user = getUser();

const state = {
    user,
    showModal: false,
};

const actions = {};

const mutations = {
    setUser(state, {
        CardType,
        CellPhone,
        Email,
        MemberID,
        Token,
        UserName
    }) {
        Vue.set(state.user, 'CardType', CardType);
        Vue.set(state.user, 'CellPhone', CellPhone);
        Vue.set(state.user, 'Email', Email);
        Vue.set(state.user, 'MemberID', MemberID);
        Vue.set(state.user, 'Token', Token);
        Vue.set(state.user, 'UserName', UserName);

        set('user', state.user);
    },
    setShowModal(state, showModal) {
        state.showModal = showModal;
    },
};

const getters = {
    isLogin(state) {
        return state.user.Token ? true : false
    },
    name(state) {
        return state.user.UserName;
    },
    phone(state) {
        return state.user.CellPhone;
    },
    email(state) {
        return state.user.Email;
    },
    avatar(state) {
        return state.avatar ? state.avatar : '/src/assets/images/icon/man_menu.svg';
    },
    MemberID() {
        return state.user.MemberID;
    },
    Token() {
        return state.user.Token;
    },
    showModal() {
        return state.showModal
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};